let analytics = require('../actions/analytics');

module.exports = {
    raiseEvent: [
        analytics.raiseArgsValueEvent
    ]
};



// WEBPACK FOOTER //
// ./signals/analytics.js